/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  SET_LOADING_SPINNER = '[Shared] set loading spinner',
  FAILED_TRANSACTION = '[Shared] Failed Transaction'
}

export const setLoadingSpinner = createAction(
  ActionTypes.SET_LOADING_SPINNER,
  props<{ status: boolean }>()
);

export const failedTransaction = createAction(
  ActionTypes.FAILED_TRANSACTION,
  props<{ data: any }>()
);